import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

// Get all templates
const getAllTemplates = async () => {
  try {
    return await axios.get(`${API_URL}/notifications-templates`);
  } catch (error) {
    throw error;
  }
};

// Get single template
const getSingleTemplate = async templateId => {
  try {
    return await axios.get(`${API_URL}/notifications-templates/${templateId}`);
  } catch (error) {
    throw error;
  }
};

// Create template
const createTemplate = async data => {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}/notifications-templates`,
      data
    });
  } catch (error) {
    throw error;
  }
};

// Update template
const updateTemplate = async (data, templateId) => {
  try {
    return await axios({
      method: 'put',
      url: `${API_URL}/notifications-templates/${templateId}`,
      data
    });
  } catch (error) {
    throw error;
  }
};

// Delete template
const deleteTemplate = async templateId => {
  try {
    return await axios.delete(`${API_URL}/notifications-templates/${templateId}`);
  } catch (error) {
    throw error;
  }
};

const templatesApi = {};

templatesApi.getAllTemplates = getAllTemplates;
templatesApi.getSingleTemplate = getSingleTemplate;
templatesApi.createTemplate = createTemplate;
templatesApi.updateTemplate = updateTemplate;
templatesApi.deleteTemplate = deleteTemplate;

export default templatesApi;
